import 'isomorphic-fetch';
import ApiKeywordsError from './ApiKeywordsError';
import { buildQueryParamsString, applyPathParamsToUrl, buildMetricsData } from '../common/utils';
import handleApiResponse from '../common/handleApiResponses/oldStyleResponse';
import { API_TIMEOUT } from '../common/constants';

const END_POINTS = {
  KEYWORDS_WHAT: '/keywords/{vertical_name}/{what_d}',
  KEYWORDS_BROWSE: '/keywords/{vertical_name}',
};

const FETCH_OPTIONS = {
  method: 'GET',
  mode: 'cors',
  timeout: API_TIMEOUT,
  headers: {
    Accept: 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  },
};

class Api {
  static fetch(url, metricsData) {
    return handleApiResponse(fetch(url, FETCH_OPTIONS), ApiKeywordsError, metricsData)
      .then(response => response)
      .catch(error => {
        throw error;
      });
  }

  static setTypeParamByVertical = verticalName =>
    verticalName === 'products' ? 'category_id' : 'type_id';

  constructor(urlBase) {
    this.urlBase = urlBase;
  }

  /**
   * Request a collection of keywords related to browse
   *
   * @param {Object} data
   * @param {string} data.country_code
   * @param {int}    data.page
   * @param {string} data.category_id
   * @param {string} data.letter
   *
   * @returns {Object}
   *
   * @throws {ApiKeywordsError}
   * @memberof Api
   */
  browseProducts(data) {
    const resource = `${this.urlBase}${END_POINTS.KEYWORDS_BROWSE}`;
    const pathParams = {
      vertical_name: data.vertical_name,
    };
    const queryParams = {
      country_code: data.country_code,
      page: data.browse_page,
      category_id: data.browse_category_id,
      first_letter: data.browse_first_letter || '',
    };

    const resourceWithParams = applyPathParamsToUrl(resource, pathParams);
    const queryParamsStr = queryParams ? buildQueryParamsString(queryParams) : '';
    const url = `${resourceWithParams}?${queryParamsStr}`;

    const metricsData = buildMetricsData(
      data.vertical_name,
      data.country_code,
      'keywords',
      'topSearches'
    );

    return Api.fetch(url, metricsData);
  }
}

export default Api;



// WEBPACK FOOTER //
// ./app/sdk/keywords/Api.js